import React from 'react';
export function useDebounce(timeout = 300, behavior = 'ignore') {
    const timeoutRef = React.useRef(null);
    const onTimeoutRef = React.useRef();
    const debounce = React.useCallback(function (fn) {
        onTimeoutRef.current = fn;
        if (timeoutRef.current !== null) {
            if (behavior === 'ignore') {
                return;
            }
            else {
                clearTimeout(timeoutRef.current);
            }
        }
        timeoutRef.current = setTimeout(() => {
            timeoutRef.current = null;
            if (onTimeoutRef.current != null)
                onTimeoutRef.current();
        }, timeout);
    }, [timeout]);
    const cancel = React.useCallback(() => {
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    return {
        debounce,
        cancel
    };
}
